import Icon from '../components/Icon.vue'

Icon.register({
  tags: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M497.9 225.9c18.7 18.7 18.7 49.1 0 67.9l-204.1 204.1c-18.7 18.7-49.1 18.7-67.9 0l-211.9-211.9c-7.8-7.8-14.1-23-14.1-33.9v-204.1c0-26.5 21.5-48 48-48h204.1c11 0 26.2 6.3 33.9 14.1zM112 160c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM625.9 293.8l-204.1 204.1c-18.7 18.7-49.1 18.7-67.9 0l-0.4-0.4 174.1-174.1c17-17 26.4-39.6 26.4-63.6s-9.4-46.6-26.4-63.6l-196.2-196.2h48.7c11 0 26.2 6.3 33.9 14.1l211.9 211.9c18.7 18.7 18.7 49.1 0 67.9z'
      }
    ]
  }
})
